import { app } from '../../../../app';
import { Controller } from './add-public-user-account.controller';

app.component('publicUserAccountsAdd', {
    bindings: {
		publicServicesWithSso$: '<',
        publicServicesWithSsoAnd2FA$: '<',
        copyAccount: '<',
        type: '<',
    },
    controller: Controller,
    templateUrl: require('./add-public-user-account.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/add/add-public-user-account.component.js